import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  DynamicDialogConfig,
  DynamicDialogRef,
  MessageService,
} from "primeng/api";
import * as _ from "underscore";

import { KaryakartaService } from "../../app/karyakarta/karyakartaService/api/karyakarta.service";
import { environment } from "../../environments/environment";
import { PinHtmlEditorComponent } from "../pin-modules/pin-html-editor-module/components/pin-html-editor/pin-html-editor.component";
import { RegisterBookService } from "../register-book/service/register-book.service";
import { PrintAPIService } from "./service/api/print.service";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
  selector: "app-html-editor",
  templateUrl: "./html-editor.component.html",
  styleUrls: ["./html-editor.component.scss"],
})
export class HtmlEditorComponent implements OnInit {
  text1: any = "";
  entityId: any;
  _templateData: any;
  dataForTemplate: any;
  _editorData: any;
  letterData: any;
  SubLetterData: any;
  selectedSubLetterType: any;
  karyaKarta?: Array<any>;
  apiBaseUrl = environment.API_BASE;
  templateObj: any;
  todaysDate = new Date();
  KaryakartaData: any;

  stepThreeFlag: boolean = false;
  index: number = 0;
  selectedKaryakarta: any;
  activeState: boolean[] = [false];
  content : string;
  showPrintPreview = false;
  headerContent: string;
  footerContent: string;
  margins: { top: string, bottom: string, left: string, right: string };
  text: string;

  @ViewChild("editorInstance", { static: false })
  editorInstance: PinHtmlEditorComponent;

  constructor(
    private service: PrintAPIService,
    private actRoute: ActivatedRoute,
    private registerService: RegisterBookService,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private toast: MessageService,
    private karyakartaService: KaryakartaService
  ) {
    this._templateData = this.config.data.registerBookData;
    this.dataForTemplate = config.data;

    this.templateObj = {
      data: "",
      registerBookId: "",
      templateMappingId: "",
    };
  }

  selectedSubLetter() {
    this.letterData = this.selectedSubLetterType;
    this.getPrintableData(this.letterData);
    
    let payload = {
      tempateIds: {
        content: this.letterData.content.id,
      },
      data: {
        receiveBy: this.dataForTemplate.receiveBy,
        documentFor: this.dataForTemplate.documentFor,
        date: this.dateFormat(this.todaysDate),
        address: this.getAddress(),
        assembly: this.getAssembly(),
        letterType: this.dataForTemplate.registerBookData.letterType.name,
      },
    };
  
    this.service.getPrintablePage(payload).subscribe((res: any) => {
      if (res) {
        res.forEach((element) => {
          this.text1 = this.text1 + element.htmlTemplate;
        });
      }
    });
  }
  
  getAddress() {
    if (this.dataForTemplate.cityType) {
      if (this.dataForTemplate.cityType.value == "VILLAGE") {
        return `${this.dataForTemplate.registerBookData.gaon.name}, ${this.dataForTemplate.registerBookData.gan_number.name}, ${this.dataForTemplate.registerBookData.gat_number.name}`;
      } else if (this.dataForTemplate.cityType.value == "CITY") {
        return `${this.dataForTemplate.registerBookData.prabhagArea.name}, ${this.dataForTemplate.registerBookData.prabhag.name}`;
      }
    }
    return "---";
  }
  
  getAssembly() {
    return this.dataForTemplate.assembly ? this.dataForTemplate.assembly.name : "---";
  }
  

  dateFormat(recievedDate) {
    let date = recievedDate;
    let d = date.getDate();
    let m = date.getMonth() + 1;
    let y = date.getFullYear();
    recievedDate =
      (d <= 9 ? "0" + d : d) + "-" + (m <= 9 ? "0" + m : m) + "-" + y;
    return recievedDate;
  }

  getPrintableData(data) {
    let address = "---";
    let assembly = "---";

    if (
      this.dataForTemplate.cityType &&
      this.dataForTemplate.cityType != undefined
    ) {
      if (this.dataForTemplate.cityType.value == "VILLAGE") {
        address =
          this.dataForTemplate.registerBookData.gaon.name +
          "," +
          this.dataForTemplate.registerBookData.gan_number.name +
          "," +
          this.dataForTemplate.registerBookData.gat_number.name;
      } else if (this.dataForTemplate.cityType.value == "CITY") {
        address =
          this.dataForTemplate.registerBookData.prabhagArea.name +
          "," +
          this.dataForTemplate.registerBookData.prabhag.name;
      }
    }

    if (
      this.dataForTemplate.assembly &&
      this.dataForTemplate.assembly != undefined
    ) {
      assembly = this.dataForTemplate.assembly.name;
    }

    let date = this.dateFormat(this.todaysDate);

    let payload = {
      tempateIds: {
        content: data.content.id,
      },

      // temp data pass
      data: {
        receiveBy: this.dataForTemplate.receiveBy,
        documentFor: this.dataForTemplate.documentFor,
        date: date,
        address: address,
        assembly: assembly,
        letterType: this.dataForTemplate.registerBookData.letterType.name,
      },
    };

    this.service.getPrintablePage(payload).subscribe((res: any) => {
      if (res) {
        res.forEach((element) => {
          this.text1 = this.text1 + element.htmlTemplate;
        });
      }
    });
  }

  saveTemplate() {
    this.templateObj = {
      data: this.editorInstance.data,
      templateMappingId: this.letterData.id,
      karyaKarta: this.selectedKaryakarta,
      // content: this.selectedSubLetterType?.content, 
    };
    this.toast.add({
      severity: "success",
      summary: "Created Successfully",
      detail: "Letter entry Created Successfully !!!",
    });

    this.ref.close(this.templateObj);
  }

  getSubLetterData() {
    let letterId = this._templateData.letterType.id;
    this.service.getSubLetters(letterId).subscribe((res) => {
      this.SubLetterData = res;
    });
  }

  printToken() {
    var win = window.open(
      "",
      "",
      "width=800,height=600,left=0,top=0,toolbar=0,scrollbars=0,status=0"
    );
    document.getElementById("messageContent").innerHTML = this.text1;
    win.document.write(document.getElementById("messageContent").innerHTML);
    win.document.close();
    win.focus();
    win.print();
    setTimeout(() => {
      win.close();
      document.getElementById("messageContent").innerHTML = "";
    }, 1000);
  }

  getKarayakartaList() {
    this.karyakartaService.getKaryakarta().subscribe((data) => {
      this.KaryakartaData = _.filter(
        data[0],
        function (e) {
          if (e.status) {
            return true;
          } else {
            false;
          }
        },
        this
      );
    });
  }

  continue() {
    this.activeState[this.index] = !this.activeState[this.index];
  }

  cancel() {
    this.selectedKaryakarta = null;
    this.text1 = null;
    this.selectedSubLetterType = null;
    this.activeState[this.index] = !this.activeState[this.index];
  }

  removeKaryakarta(karyakartaForRemove: any) {
    this.selectedKaryakarta = this.selectedKaryakarta.filter(function (
      e,
      index,
      arr
    ) {
      return e.id != karyakartaForRemove.id;
    },
    this);
  }

  ngOnInit() {
    this.entityId = this.actRoute.snapshot.paramMap.get("id");
    this.getSubLetterData();
    this.getKarayakartaList();
  }
  

  // openPrintPreview() {
  //   this.service.getPrintSettings().subscribe(
  //     (settings) => {
  //       this.headerContent = settings.header;
  //       this.footerContent = settings.footer;
  //       this.margins = settings.margins;
  //       this.showPrintPreview = true;
  //     },
  //     (error) => {
  //       console.error('प्रिंट सेटिंग्ज मिळविताना त्रुटी:', error);
  //     }
  //   );
  // }

  closePrintPreview() {
    this.showPrintPreview = false;
  }

  printPage() {
    const data = document.getElementById('print-content');
    if (data) {
      html2canvas(data, { scale: 2 }).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = 210;
        const pageHeight = 297;
        const imgWidth = 210;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let position = 0;
        let pageNumber = 1;

        while (position < imgHeight) {
          pdf.addImage(imgData, 'PNG', 0, position > 0 ? 10 : 0, imgWidth, imgHeight);
          pdf.setFontSize(10);
          pdf.text(`Page ${pageNumber}`, 190, 290);
          if (position + pageHeight < imgHeight) {
            pdf.addPage();
            position += pageHeight - 40;
            pageNumber++;
          } else {
            break;
          }
        }
        pdf.save('print-preview.pdf');
      });
    }
  }
}
